import { StaffMemberDetails } from '@/types/staff';
import { Card, Stack, Typography } from '@mui/material';
import { SVLink } from '../core';
import { useState } from 'react';
import { Status } from '@/types/common';
import ResetPasswordModal from '../modals/ResetPasswordModal';
import {
  useChangeStaffEmail,
  useChangeStaffPhone,
  useReactivateStaff,
  useResetStaffPassword,
  useStartStaffUpdate,
} from '@/hooks/requests/useStaff';
import { useScrollToTop } from '@/hooks/useScrollToTop';
import ChangeEmailModal from '../modals/ChangeEmailModal';
import ChangePhoneModal from '../modals/ChangePhoneModal';
import ReactivateModal from '../modals/ReactivateModal';
import StaffDeactivateModal from './StaffDeactivateModal';

type StaffDetailsActionsCardProps = {
  staffDetails: StaffMemberDetails;
};

export default function StaffDetailsActions({
  staffDetails,
}: StaffDetailsActionsCardProps) {
  const { uuid, status } = staffDetails;
  const { scrollToTop } = useScrollToTop();
  const [openResetPassword, setOpenResetPassword] = useState(false);
  const [openDeactivate, setOpenDeactivate] = useState(false);
  const [openReactivate, setOpenReactivate] = useState(false);
  const [openChangeEmail, setOpenChangeEmail] = useState(false);
  const [openChangePhone, setOpenChangePhone] = useState(false);

  const { resetStaffPassword, isResetStaffPasswordPending } =
    useResetStaffPassword(uuid);
  const { startStaffUpdate } = useStartStaffUpdate(uuid);
  const { changeStaffEmail, isChangeStaffEmailPending } =
    useChangeStaffEmail(uuid);
  const { changeStaffPhone, isChangeStaffPhonePending } =
    useChangeStaffPhone(uuid);
  const { reactivateStaff, isReactivateStaffPending } =
    useReactivateStaff(uuid);

  return (
    <Card variant="fullHeight">
      <Typography variant="h5" mb={2}>
        Actions
      </Typography>
      <Stack spacing={2}>
        <SVLink onClick={() => setOpenResetPassword(true)} to="">
          Reset Password
        </SVLink>
        <SVLink onClick={() => setOpenChangeEmail(true)} to="">
          Change Email
        </SVLink>
        <SVLink onClick={() => setOpenChangePhone(true)} to="">
          Change Auth Phone
        </SVLink>
        {status === Status.ACTIVE ? (
          <SVLink onClick={() => setOpenDeactivate(true)} to="" isWarningLink>
            Deactivate
          </SVLink>
        ) : (
          <SVLink onClick={() => setOpenReactivate(true)} to="" isWarningLink>
            Reactivate
          </SVLink>
        )}
      </Stack>
      <StaffDeactivateModal
        id={uuid}
        open={openDeactivate}
        setOpen={setOpenDeactivate}
      />
      <ReactivateModal
        userType="Staff"
        open={openReactivate}
        setOpen={setOpenReactivate}
        reactivate={reactivateStaff}
        isReactivatePending={isReactivateStaffPending}
        scrollToTop={scrollToTop}
      />
      <ResetPasswordModal
        userType="Staff"
        open={openResetPassword}
        setOpen={setOpenResetPassword}
        resetPassword={resetStaffPassword}
        isResetPasswordLoading={isResetStaffPasswordPending}
        scrollToTop={scrollToTop}
      />
      <ChangeEmailModal
        userType="Staff"
        open={openChangeEmail}
        setOpen={setOpenChangeEmail}
        sendOtp={startStaffUpdate}
        changeEmail={changeStaffEmail}
        isChangeEmailLoading={isChangeStaffEmailPending}
        scrollToTop={scrollToTop}
      />
      <ChangePhoneModal
        userType="Staff"
        open={openChangePhone}
        setOpen={setOpenChangePhone}
        sendOtp={startStaffUpdate}
        changePhone={changeStaffPhone}
        isChangePhonePending={isChangeStaffPhonePending}
        scrollToTop={scrollToTop}
      />
    </Card>
  );
}
